module.exports = __webpack_public_path__ + "img/404.c48b27d4.png";